import React, { useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormInput,
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import firebase from "../../fire";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

export default function CreateVideo() {
  // const currentDate = new Date();
  // const currentDatePlusHour = moment(currentDate).add("hour", +1);
  var today = new Date();
  today.setHours(today.getHours() + 1);
  const [vidtitle, setVidTitle] = useState("");
  const [file, setFile] = useState("");
  const [reward, setReward] = useState("");
  const [totalReward, settotalReward] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(today);
  const [isLoading, setLoading] = useState(false);
  const [thumbnail, setthumbnail] = useState("");

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (vidtitle && endDate && startDate && file && thumbnail) {
      setLoading(true);
      const storageRef = firebase.storage().ref();
      const fileRef = storageRef.child("videos/" + file.name);
      const thumbnailRef = storageRef.child("thumbnail/" + thumbnail?.name);
      fileRef.put(file).then(async (result) => {
        fileRef.getDownloadURL().then(function (downloadURL) {
          thumbnailRef.put(thumbnail).then(async (result) => {
            thumbnailRef.getDownloadURL().then(function (thumnailURL) {
              const db = firebase.firestore();
              const userRef = db.collection("videos").add({
                name: vidtitle,
                file_name: downloadURL,
                start_date: String(moment(startDate)),
                end_date: String(moment(endDate)),
                reward: reward,
                reward_distributed: false,
                total_prize: 10,
                view_by: [],
                ads: [],
                live_view: [],
                thumbnail: thumnailURL,
              });
            });
          });

          setLoading(false);
        });
        await Swal.fire("Video", "Video uploaded successfully", "success");
      });
    } else {
      await Swal.fire("Error", "Kindly input all the fields", "error");
    }
  };
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Add New Video"
          subtitle="Video "
          className="text-sm-left"
        />
      </Row>

      <Row>
        <Col lg="9" md="12">
          <Card small className="mb-3">
            <CardBody>
              <form>
                <div class="form-group">
                  <label for="exampleInputFullname"> Video Title </label>
                  <input
                    type="text"
                    value={vidtitle}
                    onChange={(e) => setVidTitle(e.target.value)}
                    name="startDate"
                    class="form-control"
                    id="exampleInputFullname"
                    aria-describedby="fullnameHelp"
                    placeholder="Enter Video Title "
                  />
                </div>
                <div class="form-group">
                  <label for="startDate">Start Date And Time </label>
                  {/* <input
                    type="datetime-local"
                    value={startDate}
                    onChange={setStartDate}
                    name="startDate"
                    class="form-control"
                    id="startDate"
                    aria-describedby="fullnameHelp"
                    placeholder="Start Date "
                  /> */}
                  <br />
                  <DateTimePicker
                    onChange={setStartDate}
                    value={startDate}
                    minDate={new Date()}
                  />
                </div>
                <div class="form-group">
                  <label for="endDate">End Date And TIme </label>
                  <br />
                  {/* <input
                    type="datetime-local"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    name="endDate"
                    class="form-control"
                    id="endDate"
                    aria-describedby="emailHelp"
                    placeholder="Enter email"
                  /> */}
                  <DateTimePicker
                    onChange={setEndDate}
                    value={endDate}
                    minDate={new Date()}
                  />
                </div>
                <div class="form-group">
                  <label for="reward">Reward $</label>
                  <input
                    type="number"
                    value={reward}
                    onChange={(e) => setReward(e.target.value)}
                    class="form-control"
                    id="reward"
                    placeholder="Enter Reward"
                  />
                </div>
                <div class="form-group">
                  <label for="reward">Total No of People</label>
                  <input
                    type="number"
                    value={totalReward}
                    onChange={(e) => settotalReward(e.target.value)}
                    class="form-control"
                    id="reward"
                    placeholder="Enter No of People Get Reward"
                  />
                </div>
                <div class="form-group">
                  <label for="video">Video</label>
                  <input
                    type="file"
                    // onChange={(e) => setReward(e.target.value)}
                    class="form-control"
                    accept="video/mp4,video/x-m4v,video/*"
                    id="video"
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </div>

                <div class="form-group">
                  <label for="video">Thumbnail Image</label>
                  <input
                    type="file"
                    class="form-control"
                    id="image"
                    onChange={(e) => setthumbnail(e.target.files[0])}
                  />
                </div>

                <button
                  disabled={isLoading}
                  type="submit"
                  class="btn btn-primary"
                  onClick={handleSubmit}
                >
                  {isLoading && <i className="fa fa-refresh fa-spin mr-1"></i>}
                  Upload
                </button>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
